// Teacher dashboard
import React, { useState, useCallback } from 'react';
import View from 'src/pages/teachers/overview';
import AppRender from 'src/routes/app-render';
import { getMyOrderWorking } from 'src/api/teachers/overview';

export const Page = () => {
  const [data, setData] = useState();
  const fetchData = useCallback(async () => {
    let result = await getMyOrderWorking();
    setData(result || []);
  }, []);
  
  return (
    <AppRender apiCall={fetchData}>
      {data && <View orders={data} />}
    </AppRender>
  );
};

export default Page;
